import i18n from '../../locales/i18n'
import { LanguageCodes } from './languages'

export const CurrencyCodesMap = {
  [LanguageCodes['en-US']]: 'USD',
  [LanguageCodes['ca-ES']]: 'EUR',
  [LanguageCodes['es-ES']]: 'EUR',
  [LanguageCodes['pt-PT']]: 'EUR',
  [LanguageCodes['pt-BR']]: 'BRL',
}

// Prices on UI
const TerminalCostPriceMap = {
  [LanguageCodes['en-US']]: 300,
  [LanguageCodes['ca-ES']]: 300,
  [LanguageCodes['es-ES']]: 300,
  [LanguageCodes['pt-BR']]: 300,
  [LanguageCodes['pt-PT']]: 300,
}

const ChargebacksFeePriceMap = {
  [LanguageCodes['en-US']]: 25,
  [LanguageCodes['ca-ES']]: 25,
  [LanguageCodes['es-ES']]: 25,
  [LanguageCodes['pt-BR']]: 25,
  [LanguageCodes['pt-PT']]: 25,
}

const CreditCardVoiceAuthorizationPriceMap = {
  [LanguageCodes['en-US']]: 0.65,
  [LanguageCodes['ca-ES']]: 0.65,
  [LanguageCodes['es-ES']]: 0.65,
  [LanguageCodes['pt-BR']]: 0.65,
  [LanguageCodes['pt-PT']]: 0.65,
}

const InsufficientFundsPriceMap = {
  [LanguageCodes['en-US']]: 30,
  [LanguageCodes['ca-ES']]: 30,
  [LanguageCodes['es-ES']]: 30,
  [LanguageCodes['pt-BR']]: 30,
  [LanguageCodes['pt-PT']]: 30,
}

const PricePerTransactionMap = {
  [LanguageCodes['en-US']]: 0.35,
  [LanguageCodes['ca-ES']]: 0.35,
  [LanguageCodes['es-ES']]: 0.35,
  [LanguageCodes['pt-BR']]: 0.35,
  [LanguageCodes['pt-PT']]: 0.35,
}

const RhapsodyGoPriceMap = {
  [LanguageCodes['en-US']]: 50,
  [LanguageCodes['ca-ES']]: 50,
  [LanguageCodes['es-ES']]: 50,
  [LanguageCodes['pt-BR']]: 50,
  [LanguageCodes['pt-PT']]: 50,
}

const TERMINAL_COST = TerminalCostPriceMap[i18n.language] || 300
const CHARGEBACKS_FEE = ChargebacksFeePriceMap[i18n.language] || 25
const CREDIT_CARD_VOICE_AUTHORIZATION =
  CreditCardVoiceAuthorizationPriceMap[i18n.language] || 0.65
const INSUFFICIENT_FUNDS = InsufficientFundsPriceMap[i18n.language] || 30
const PER_TRANSACTION = PricePerTransactionMap[i18n.language] || 0.35
const RHAPSODY_GO = RhapsodyGoPriceMap[i18n.language] || 50

export const DefaultPrices = {
  TERMINAL_COST,
  CHARGEBACKS_FEE,
  CREDIT_CARD_VOICE_AUTHORIZATION,
  INSUFFICIENT_FUNDS,
  PER_TRANSACTION,
  RHAPSODY_GO,
}
